import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-hash-tag-info',
  templateUrl: './hash-tag-info.component.html',
  styleUrls: ['./hash-tag-info.component.scss'],
  imports:[DependenciesModule]
})
export class HashTagInfoComponent implements OnInit {

  @Output() closeInfo = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  close(){
    this.closeInfo.emit();
  }

}
